import * as XLSX from 'xlsx'
export default {
    downloadXlsx(arrayData, name = 'errors.xlsx') {
        const data = XLSX.utils.json_to_sheet(arrayData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, data, "data");
        XLSX.writeFile(wb, name);
    }
}